import NotesContainer from './NotesContainer'

export default NotesContainer
